import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import type { MapRef } from 'react-map-gl';
import { getMapDefaultConfig } from 'components/map/atoms';
import { createMutationAtom } from 'atoms/create-resource-atom';
import type {
  WellIntersectionAnalysisResponse,
  WellMapResponse,
} from 'types/api-responses';

export const afeCatalogMapConfigAtom = atomWithStorage(
  'insights-afe-catalog-map-config',
  getMapDefaultConfig({
    wells: {
      checked: false,
      options: {
        surfaceHole: true,
        bottomHole: true,
        stick: true,
        survey: true,
        vertical: false,
      },
    },
  })
);

export const afeCatalogMapRefAtom = atom<MapRef | null>(null);

export const afeCatalogWellMapMutationAtom = createMutationAtom<
  WellMapResponse,
  'wellMap'
>();

export const afeCatalogWellIntersectionMutationAtom = createMutationAtom<
  WellIntersectionAnalysisResponse,
  'wellIntersectionAnalysis'
>();
